import request from './HttpService';
import { ENDPOINTS } from '../utils/constants';

export const getRegistrationDetail = async (reservationId: string) => {
  const response = await request.get(ENDPOINTS.registrationConfiguration(reservationId));
  return response.data.data;
};

export const getDeliveryDetail = async (reservationId: string) => {
  const response = await request.get(ENDPOINTS.deliveryConfiguration(reservationId));
  return response.data.data;
};

export const getDocumentDetails = async (reservationId: string) => {
  return {
    frontLicensePlate: 'Install',
    plateTransfer: 'Personalized Plates',
    registrationExpiration: new Date().toISOString(),
    plateNumner: 'Sunplate',
    model: 'Dream Edition',
    currentCarVIN: '123',
    notes: 'Additional notes',
    state: 'Alaska',
    isArizona: false,
    makeRegistrationExpiration: new Date().toISOString(),
    make: 'Honda',
    makeModel: '',
  };
};
